import { makeStyles, Theme } from "@material-ui/core/";
import { placeBackgroundColor } from "../../services/utils";

const useStyles = makeStyles((theme: any) => ({
  optionStyle: {
    color: theme.palette.colors.menuFont,
    fontSize: "13px !important",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "100%",
    minHeight: '19px !important',
  },
  optionText: {
    fontSize: "0.8125rem",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  selectContainer: {
    height: "36px",
    width: "20%",
    backgroundColor: "transparent !important",
    "&:disabled": {
      backgroundColor: "transparent !important"
    },
    "& .select-arrow-icon": {
      fill: `${theme.palette.colors.menuFont} !important`,
      width: "36px !important",
      height: "36px !important",
      right: "0 !important"
    },
  },
  selectStyle: {
    color: `${theme.palette.colors.menuFont} !important`,
    ...placeBackgroundColor(theme.palette.background.topDropDownSelect),
    borderRadius: "4px !important",
    border: "none !important",
    boxShadow: "none !important",
    padding: "0 9px !important",
    height: "36px !important",
    fontSize: "0.8125rem !important",
    "&:hover": {
      ...placeBackgroundColor(theme.palette.background.topDropDownSelect),
    }
  },
  menuStyle: {
    ...placeBackgroundColor(theme.palette.background.topDropDownDropDown),
    "& .select-options-list": {
      maxHeight: "calc(100vh - 120px) !important",
    },
    "& *": {
      color: `${theme.palette.colors.menuFont} !important`,
    },
    "& .select-option-selected": {
      ...placeBackgroundColor(theme.palette.background.topDropDownDropDownSelected),
    },
    "& .select-option-selected.select-option-hovered": {
      ...placeBackgroundColor(theme.palette.background.topDropDownDropDownSelected),
    },
  },
  inputStyle: {},
  iconStyle: {
    right: "0"
  },
  focusStyle: {
    "&:focus": {
      backgroundColor: theme.palette.primary.light,
      borderRadius: "4px"
    }
  },
  arrowIcon: {
    color: "#fff",
    fontSize: "2.5rem !important",
    top: "0",
    height: "36px"
  },
  paperStyle: {
    backgroundColor: theme.palette.background.topDropDownDropDown
  },
  selected: {
    ...placeBackgroundColor(theme.palette.background.topDropDownDropDownSelected),

  },
  input: {
    color: theme.palette.colors.menuFont
  },
  textField: {
    "& fieldset": {
      borderColor: "rgba(170, 162, 170, 0.3)",
    },
    "&:hover": {
      "& fieldset": {
        borderColor: "rgba(170, 162, 170, 0.3) !important"
      }
    }
  },
  hideOption: {
    visibility: "hidden",
    height: 0,
    padding: 0
  },
  subHeader: {
    position: "unset"
  }
}));

export default useStyles;
